<template>
  <nav
    ref="navigation"
    :class="classList"
    class="c-navigation z-50 fixed inset-0 flex ltr:lg:right-auto rtl:lg:left-auto"
    @click="onClick"
  >
    <div
      :class="classScroll"
      class="c-navigation__body overflow-y-auto w-4/5 ltr:pl-5 rtl:pr-5 ltr:pr-3 rtl:pl-3 pt-6 shadow-2xl lg:w-full lg:shadow-none"
    >
      <c-logo class="ltr:pr-2 rtl:pl-2 pb-5"/>
      <div class="ltr:pl-2 rtl:pr-2 pb-4">
        <c-search/>
      </div>
      <c-list :list="list" :selected="selected" color="primary" margin-item="4px"/>
    </div>
  </nav>
</template>

<script>
import CList from '@/components/CList'
import CLogo from '@/components/CLogo'
import CSearch from '@/components/CSearch'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import useScroll from 'dcode/uses/useScroll'

export default {
  name: 'CNavigation',
  components: {
    CList,
    CLogo,
    CSearch
  },
  setup () {
    const store = useStore()

    const navigation = ref(undefined)
    const list = computed(() => store.getters.getNavigation)

    const classList = computed(() => {
      return { 'status-open': store.getters.getNavigationStatus }
    })
    const classScroll = useScroll()

    const onClick = ({ target }) => {
      if (target === navigation.value) {
        store.commit('setNavigationStatus')
      }
    }

    return {
      navigation,
      list,
      selected: computed(() => store.getters.getValue),
      classList,
      classScroll,
      onClick
    }
  }
}
</script>

<style lang="scss">
@import "style";
</style>
